import Q1 from './Q1';
import Q2 from './Q2';
import Q3 from './Q3';
import Q4 from './Q4';
import Q5 from './Q5';
import Q6 from './Q6';
import Q7 from './Q7';
import Q8 from './Q8';
import PFMT from './PMFT';
import Pm from './Pm/Pm';
import PmPre from './Pm/PmPre';
import PmUnitVector from './Pm/UnitVector';
import Po from './Po/Po';
import PoPre from './Po/PoPre';
import PoUnitVector from './Po/UnitVector';
import MedialRecords from './MedialRecords';
import Formula from './Formula';
import Prior from "./Prior";
import R1 from './R1';
import R2 from './R2';
import Graph1 from './Graph1';
import Graph2 from './Graph2';
import Graph3 from './Graph3';
import Graph4 from './Graph4';
import Px from './Px';
import Pe from './Pe';
import Pd from './Pd';
import Recommend from './Recomend';
import SafeRelated from './SafeRelated';
import Patient from './Patient';
import Doctor from './Doctor';
import FakeLine from './FakeLine';
import FakeNode from './FakeNode';

export default {
  Patient, Doctor,
  PFMT,
  Q1, Q2, Q3, Q4, Q5, Q6, Q7, Q8,
  Pm, PmPre, PmUnitVector,
  Prior, Po, PoPre, PoUnitVector,
  Formula,
  MedialRecords, 
  R1, R2, Graph1, Graph2, Graph3, Graph4,
  Px, Pe, Pd,
  Recommend, SafeRelated,
  FakeLine, FakeNode
}